/*-------------------------------------------------------------------
関数定義
--------------------------------------------------------------------*/
function isPc() {
  return window.innerWidth > 768;
}
// Mobileの場合True
function isMobile() {
  return !isPc();
}

/**
 * 指定の要素のテキストを1文字ずつspanで囲む
 */
const wrapSpan = () => {
  const textWrap = document.querySelectorAll('.js-wrapSpan');
  textWrap.forEach((t) => (
    t.innerHTML = t.textContent.replace(/\S/g, '<span>$&</span>')
  ));
}

/**
 * アンカーリンク
*/
function scrollHash() {
  const hash = location.hash;
  if (hash && jQuery(hash).length) {
    const offset = jQuery(hash).offset().top;
    const scrollto = offset - (("fixed" !== jQuery("#header").css("position")) ? (headerHeight + 20) : 0);
    jQuery('html, body').animate({ scrollTop: scrollto }, 500);
  }
}


/*-------------------------------------------------------------------
読み込み時実行
--------------------------------------------------------------------*/
let headerHeight = document.querySelector('.js-header').offsetHeight;
wrapSpan();

/*-------------------------------------------------------------------
イベント
--------------------------------------------------------------------*/
/**
 * スクロールバーを除いた画面幅の取得
 */
jQuery(window).on('load resize', function () {
  let vw = document.body.clientWidth;// スクロールバーを除いた幅を取得
  let vh = window.innerHeight; // アドレスバーを覗いた画面高さ
  headerHeight = document.querySelector('.js-header').offsetHeight;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

  // let markHeight = jQuery('.js-marks').outerHeight(true);
  // console.log(markHeight);
  // let maxItemHeight = 0;
  // jQuery('.js-scrollItem').each(function () {
  //   if (jQuery(this).outerHeight() > maxItemHeight) {
  //     maxItemHeight = jQuery(this).outerHeight();
  //   }
  // });

  // console.log(maxItemHeight);

  // jQuery('.js-pointItems').css('height', maxItemHeight)
  // jQuery('.js-scrollWrap').css('height', markHeight + maxItemHeight + 10);


});

const items = document.querySelectorAll('.js-scrollItem');
const marks = document.querySelectorAll('.js-mark');
const activeMarks = document.querySelectorAll('.js-activeMark');
const footerItems = document.querySelectorAll('.js-pointsFooterItem');

let scrolltriggeritem;
jQuery(window).on("load", function () {
  items.forEach((el, index) => {
    if (index != 0) {
      gsap.set(el, { autoAlpha: 0 });
    }
  });
  // jQuery(marks[0]).addClass('is-active');
  gsap.set(activeMarks[0], { clipPath: 'inset(0 0% 0 0)' })


  let activeItemIndex = 0;
  let beforeProgress = 0;
  scrolltriggeritem = ScrollTrigger.create({
    ease: 'none',
    trigger: '.js-scrollTriggerTarget',
    start: 'top top',
    end: '+=' + (window.innerHeight * items.length),
    pin: true,
    // pinSpacing: false,
    // markers: true,
    onUpdate: (self) => {
      let index = Math.min(Math.floor(self.progress * items.length), items.length - 1);
      if (index != activeItemIndex) {
        if (beforeProgress < self.progress) {
          gsap.set(activeMarks[activeItemIndex], { clipPath: 'inset(0 0 0 0)' });
          gsap.to(activeMarks[activeItemIndex], { clipPath: 'inset(0 0 0 100%)' });
        } else {
          gsap.set(activeMarks[activeItemIndex], { clipPath: 'inset(0 0 0 0)' });
          gsap.to(activeMarks[activeItemIndex], { clipPath: 'inset(0 100% 0 0)' });
        }
        gsap.to(items[activeItemIndex], { autoAlpha: 0 });
        // gsap.to(footerItems[activeItemIndex], { display: 'none' });
        jQuery(footerItems[activeItemIndex]).fadeOut();

        activeItemIndex = index;

        if (beforeProgress < self.progress) {
          gsap.set(activeMarks[activeItemIndex], { clipPath: 'inset(0 0 0 100%)' });
          gsap.to(activeMarks[activeItemIndex], { clipPath: 'inset(0 0 0 0%)' });
        } else {
          gsap.set(activeMarks[activeItemIndex], { clipPath: 'inset(0 100% 0 0)' });
          gsap.to(activeMarks[activeItemIndex], { clipPath: 'inset(0 0% 0 0)' });
        }
        gsap.to(items[activeItemIndex], { autoAlpha: 1 });
        // gsap.to(footerItems[activeItemIndex], { display: 'block' });
        jQuery(footerItems[activeItemIndex]).fadeIn();
      }
      beforeProgress = self.progress;
    },
  });

});


jQuery(function () {
  scrollHash();

  // 画面遷移
  // jQuery(document).on('click', 'a:not([href*="#"]):not([target]):not([href*="mailto"]):not([href*="tel"])', function (event) {
  //   event.preventDefault();
  //   const url = jQuery(this).attr('href');

  //   if ((event.ctrlKey && !event.metaKey) || (!event.ctrlKey && event.metaKey)) {
  //     // ctrl(command) + click 時に別ウィンドウで開く処理
  //     window.open(url, '_blank');
  //     return false;
  //   }


  //   if (url !== '') {
  //     jQuery('body').fadeOut(500);
  //     setTimeout(() => {
  //       window.location = url;
  //     }, 500);
  //   }
  // });

  // スクロール判定
  jQuery(window).on("scroll", function () {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let documentHeight = jQuery(document).height();

    if (100 < scrollTop) {
      jQuery("body").attr("data-scroll", "true");
    } else {
      jQuery("body").attr("data-scroll", "false");
    }

    if (documentHeight - (windowHeight + scrollTop) <= 0) {
      jQuery("body").attr("data-scroll-bottom", "true");
    } else {
      jQuery("body").attr("data-scroll-bottom", "false");
    }

    // /**
    //  * トップに戻るボタン
    //  */
    // const totop = jQuery('.js-totop');
    // const totopTarget = jQuery(`.${totop.data("target")}`);
    // if ((totopTarget.length ? totopTarget.innerHeight() : headerHeight) < scrollTop) {
    //   totop.addClass('is-active');
    // } else {
    //   totop.removeClass('is-active');
    // }

    /**
    * トップに戻るボタンをフッターで固定
    */
    // const totopHeight = totop.innerHeight();
    // const scrollPosition = jQuery(window).height() + jQuery(window).scrollTop();
    // const fixHeight = jQuery(".js-footer").innerHeight();
    // const bottom = totopHeight / 2;
    // if (documentHeight - scrollPosition + bottom <= fixHeight) {
    //   // ページトップボタンがフッター手前に来たらpositionとfixedからabsoluteに変更
    //   totop.css({
    //     position: "absolute",
    //     bottom: fixHeight - (totopHeight / 2),
    //   });
    // } else {
    //   totop.css({
    //     position: "fixed",
    //     // bottom: bottom,
    //     bottom: "0",
    //   });
    // }

  });

  /* ドロワー */
  jQuery(".js-drawer").on("click", function (event) {
    event.preventDefault();
    const ariaControls = jQuery(this).attr("aria-controls");
    const addClass = 'is-opened'

    if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
      jQuery(`#${ariaControls}`).removeClass(addClass);
    } else {
      jQuery(`#${ariaControls}`).addClass(addClass);
    }

    jQuery(`[aria-controls=${ariaControls}]`).each(function () {
      jQuery(this).attr("aria-expanded", (jQuery(`#${ariaControls}`).hasClass(addClass) ? 'false' : 'true'));
      if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
        jQuery(this).addClass(addClass);
        jQuery('.js-header').css({ 'z-index': 22 })
      } else {
        jQuery(this).removeClass(addClass);
        jQuery('.js-header').css({ 'z-index': 20 })
      }
    });

    // ドロワー開時にbody要素がスクロールしないように
    (jQuery(`#${ariaControls}`).hasClass(addClass) ? jQuery('body').addClass('u-overflowHidden') : jQuery('body').removeClass('u-overflowHidden'));

    return false;
  });

  /**
   * ドロワー内のページ内リンククリック時に閉じる
   */
  jQuery('#drawer-content1 a').on('click', function (event) {
    const currentUrl = location.protocol + '//' + location.host + location.pathname; // 現在のURL
    const href = jQuery(this).prop("href");
    const hrefUrl = href.split('#')[0];   // リンク先のURL

    // if (currentUrl == hrefUrl) {
    jQuery('.for-drawer').removeClass('is-opened');
    jQuery('#drawer-content1').attr('aria-hidden', true);
    jQuery('body').removeClass('u-overflowHidden');
    // }
  });

  // ヘッダ
  // jQuery(window).on('load scroll', function () {
  //   // if (jQuery('body').hasClass('home')) {
  //   const $header = jQuery('.js-header');
  //   if ($header.length) {
  //     const target = jQuery(`.${jQuery($header).data('target')}`);
  //     const targetHeight = (target.length ? target.innerHeight() : headerHeight * 1.1);
  //     let position = jQuery(this).scrollTop();
  //     if (position > targetHeight) {
  //       $header.addClass('is-fixed');
  //     } else if (position == 0) {
  //       $header.removeClass('is-fixed');
  //     }
  //   }
  //   // }
  // });


  /* スムーススクロール */
  jQuery(document).on('click', 'a[href*="#"]:not(".js-tabIndex, .js-modal, .js-accordion")', function (e) {
    // e.preventDefault();
    const currentUrl = location.protocol + '//' + location.host + location.pathname; // 現在のURL
    const href = jQuery(this).prop("href");
    const hrefUrl = href.split('#')[0];   // リンク先のURL
    // let target = $(this.hash);
    // if (!target.length) return;

    if (currentUrl == hrefUrl) {
      let id = '#' + href.split('#')[1];  // リンク先のアンカー
      let speed = 300;
      let target = jQuery("#" == id ? "html" : id);
      let position = target.offset().top - (headerHeight + 20);
      if ("fixed" !== jQuery("#header").css("position")) {
        position = target.offset().top;
      }
      if (0 > position) {
        position = 0;
      }
      jQuery("html, body").animate({
        scrollTop: position
      }, speed);
      jQuery(this).blur();
      // return false;
    }
  });

  /* 電話リンク */
  let $ua = navigator.userAgent;
  if ($ua.indexOf("iPhone") < 0 && $ua.indexOf("Android") < 0) {  // PCのとき
    jQuery('a[href^="tel:"]') // 電話リンク
      .css("cursor", "default") // カーソルをポインターにしない
      .css('pointer-events', 'none')  // ホバーなども動作しない
      .on("click", function (e) {
        e.preventDefault();
      });
  }
});
